import BaseModulePlugins from '@/store/baseModule/plugins';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['properties', 'interventions', 'planned'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['event_datetime'],
        }),
      }),
      attributesObj: {
        reference: { serverSide: true, values: [] },
        scheduled_type: { serverSide: true, values: ['P'] },
      },
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/properties/${id}/interventions_in_progress`,
      makeQueryParams: makeListRequest({
        useEntities: false,
        dateField: 'event_datetime',
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'properties/interventions/planned',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.onActiveRequestChange((payload) => {
      store.dispatch('properties/interventions/planned/setAttributesObj', {
        ...store.getters['properties/interventions/planned/attributesObj'],
        reference: {
          ...store.getters['properties/interventions/planned/attributesObj']
            .reference,
          serverSide: true,
          values: [],
        },
      });
      store.dispatch(
        'properties/interventions/planned/setUrlParamId',
        payload.property_id
      );
    });
  });
};
